// Centralized portfolio projects configuration
// Used by: routes (App.js), portfolio page, and project detail pages
// 
// Projects are defined in portfolioProjects.json for easy sharing between
// Node.js scripts and React components

import PROJECTS_DATA from "./portfolioProjects.json";

const arrayRange = (start, stop, step) =>
  Array.from(
    { length: (stop - start) / step + 1 },
    (value, index) => start + index * step
  );

export const PORTFOLIO_PROJECTS = PROJECTS_DATA;

// Helper to get project by slug
export const getProjectBySlug = (slug) =>
  PORTFOLIO_PROJECTS.find((p) => p.slug === slug);

// Helper to generate column arrays for desktop layout
export const getDesktopColumns = (imageCount) => ({
  column1: arrayRange(1, imageCount, 2),
  column2: arrayRange(2, imageCount, 2),
});

// Helper to generate single column array for mobile layout
export const getMobileColumn = (imageCount) => arrayRange(1, imageCount, 1);

// Helper to get project URL
export const getProjectUrl = (slug) => `/portfolio/${slug}`;
